import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";

import CommonTextBox from "../commonFields/commonTextBox";

import { changePasswordValidationSchema } from "../../validationSchemas/userValidation";
import { IChangePassowrd } from "../../interfaces/userInterface";

import close from "../../assets/images/close.png";
import show from "../../assets/images/Show.svg";
import hide from "../../assets/images/Hide.svg";
import CommonButton from "../commonFields/CommonButton";
import SVGFiles from "../SVGFiles";

type Props = {
  closeModal: () => void;
  getdata: (data: IChangePassowrd) => void;
  loading: boolean;
};

const PasswordModal: React.FC<Props> = (props) => {
  const { closeModal, getdata, loading } = props;
  const { t: translation } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(changePasswordValidationSchema(translation)),
  });

  const [showOldPassword, setShowOldPassord] = useState(false);
  const [showPassword, setShowPassord] = useState(false);
  const [showConfirmPassword, setShowConfirmPassord] = useState(false);

  const onSubmit = async (data: IChangePassowrd) => {
    getdata(data);
  };

  return (
    <div
      className="modal  modal-custom-show"
      id="exampleModal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center p-5 close-btn">
            <CommonButton
              type="button"
              className="btn-close close-inner theme-button"
              onClick={closeModal}
            >
              <img src={close} alt="" />
            </CommonButton>

            <h4 className="mb-3 space">
              <b>
                <span className="color-theme">
                  {translation("modal_change")}
                </span>{" "}
                {translation("modal_password")}
              </b>
            </h4>
            <form
              onSubmit={handleSubmit((data) =>
                onSubmit(data as IChangePassowrd)
              )}
              noValidate
            >
              <div className="form-group">
                <div className="double-icon-input">
                  <CommonTextBox
                    control={control}
                    name="old_password"
                    type={showOldPassword ? "text" : "password"}
                    className="form-control"
                    placeHolder={translation("old_password")}
                    error={errors.old_password}
                  />
                  <span className="left-cion">
                   <SVGFiles name="lockIcon" />
                  </span>
                  <span className="right-icon">
                    {!showOldPassword ? (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() => setShowOldPassord(!showOldPassword)}
                      >
                        <img src={hide} alt="" />
                      </CommonButton>
                    ) : (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() => setShowOldPassord(!showOldPassword)}
                      >
                        <img src={show} alt="" />
                      </CommonButton>
                    )}
                  </span>
                </div>
              </div>
              <div className="form-group">
                <div className="double-icon-input">
                  <CommonTextBox
                    control={control}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeHolder={translation("Password")}
                    error={errors.password}
                  />
                  <span className="left-cion">
                   <SVGFiles name="lockIcon" />

                  </span>
                  <span className="right-icon">
                    {!showPassword ? (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() => setShowPassord(!showPassword)}
                      >
                        <img src={hide} alt="" />
                      </CommonButton>
                    ) : (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() => setShowPassord(!showPassword)}
                      >
                        <img src={show} alt="" />
                      </CommonButton>
                    )}
                  </span>
                </div>
              </div>
              <div className="form-group">
                <div className="double-icon-input">
                  <CommonTextBox
                    control={control}
                    name="confirm_password"
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeHolder={translation("confirm_password")}
                    error={errors.confirm_password}
                  />
                  <span className="left-cion">
                    <SVGFiles name="lockIcon" />
                  </span>
                  <span className="right-icon">
                    {!showConfirmPassword ? (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() =>
                          setShowConfirmPassord(!showConfirmPassword)
                        }
                      >
                        <img src={hide} alt="" />
                      </CommonButton>
                    ) : (
                      <CommonButton
                        className="theme-button trans-btn"
                        type="button"
                        onClick={() =>
                          setShowConfirmPassord(!showConfirmPassword)
                        }
                      >
                        <img src={show} alt="" />
                      </CommonButton>
                    )}
                  </span>
                </div>
              </div>

              <CommonButton
                className="theme-button primary-btn w-100"
                type="submit"
                disabled={loading}
              >
                {translation("update_password_button")}{" "}
                {loading && (
                  <div className="spinner-border text-light" role="status" />
                )}
              </CommonButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
